<template>
  <div id="home">
    <el-container class="layout jhh-layou">
      <el-header>
        <nav class="jhh-page-tabs">
          <div class="fl jhh-logo el-col-4" @click="goHome()" style="width: 220px;">
            <img src="../assets/images/quanfu_logo.jpg" alt="">
          </div>
          <div class="jhh-tag fl">
            <h2>您身边的手机上门快修专家</h2>
          </div>
          <div v-if="weatherInfo" class="" style="float: left !important;margin-top: 0;width: 30%;margin-left: 3%;">

            <el-carousel height="50px" direction="vertical" :autoplay="true"  :interval="5000" indicator-position="none">
              <el-carousel-item v-for="(item,index) in weatherInfo.daily" :key="index">
                <h3 class="medium user-center">
                  <img v-bind:src="item.imageUrl" alte="" style="border: 0;vertical-align: sub;">
                  <span style="position: fixed">
                    <ul style="list-style-type: none;margin: 0;padding: 0;">
                      <li style="height: 20px;line-height: 20px;padding: 2px 0 0;overflow: hidden;">
                        <span style="">{{item.date}}</span>
                         <span>{{weatherInfo.location.name}}</span>
                      </li>
                      <li style="height: 20px;line-height: 20px;padding: 2px 0 0;overflow: hidden;">
                        <span style="">{{item.textDay}}</span>
                         <span>{{item.low}}℃~{{item.high}}℃</span>
                      </li>
                    </ul>
                  </span>
                </h3>

              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="jhh-user fr">
                        <span class="user-welcome fl" style="margin-right:50px" v-loading="isChangeonline">
                            <span v-if=" isOnline == 0" class="offline-status "
                                  @click="updateAutomaticOrderOpe(1)">离线</span>
                            <span v-if="isOnline == 1" class="online-status"
                                  @click="updateAutomaticOrderOpe(0)">在线</span>
                        </span>
            <span class="user-welcome fl">
                            欢迎登录,{{hoursTip}},<span v-if="userName !==''">&nbsp;{{roleName}}&nbsp;</span>
                        </span>
            <div class="jhh-user-pic fl" @click="toggleSetting()" v-if="userName === 'admin'">
              <img src="../assets/images/engineerImg.png" alt="">
            </div>
            <el-dropdown trigger="click" class="user-center fl">
                            <span class="el-dropdown-link">
                                个人中心<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native='toHelp()'>帮助中心</el-dropdown-item>
                <el-dropdown-item @click.native="changePsw()">修改密码</el-dropdown-item>
                <el-dropdown-item @click.native="logout()">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </nav>
        <el-dialog
          title="修改密码"
          :visible.sync="billdialog"
          width="700px"
          append-to-body>
          <el-form :label-position="labelPosition" label-width="100px" ref="form" :model="form" :rules="rules">
            <el-form-item label="登录名：" prop="loginName">
              <el-input v-model.trim="form.loginName" type="text" disabled></el-input>
            </el-form-item>
            <el-form-item label="原密码：" prop="old_password">
              <el-input v-model.trim="form.old_password" type="password"></el-input>
            </el-form-item>
            <el-form-item label="新密码：" prop="new_password">
              <el-input v-model.trim="form.new_password" type="password"></el-input>
            </el-form-item>
            <el-form-item label="密码强度：">
              <div v-text="form.checkstrong" class="isActive"
                   :class="{'isActive1': form.checkstrong === '中','isActive2': form.checkstrong === '强'}">
              </div>
            </el-form-item>
            <el-form-item label="确认密码：" prop="new_password2">
              <el-input v-model.trim="form.new_password2" type="password"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="submitFormPsw('form')">提交</el-button>
                        <el-button type="warning" @click="billdialog = false">关闭</el-button>
                    </span>
        </el-dialog>
      </el-header>
      <el-container>
        <el-aside class="layout-menu-left">
          <!-- style="height: 100%"-->
          <el-scrollbar style="height: 100%;margin-bottom: 25%">
            <AppNav :menus="menus"></AppNav>
          </el-scrollbar>
        </el-aside>
        <el-container>
          <el-main :span="20" class="app-content">
            <div class="app-wrap">
              <!-- 此处放置el-tabs代码 -->
              <div class="template-tabs">
                <el-tabs
                  v-model="activeIndex"
                  type="border-card"
                  @tab-click="tabClick"
                  v-if="options.length"
                  @tab-remove="tabRemove">
                  <el-tab-pane
                    :closable="item.name != '首页'"
                    v-for="(item, index) in options"
                    :key="item.name"
                    :label="item.name"
                    :name="item.route">
                  </el-tab-pane>
                  <div class="content-wrap">
                    <keep-alive>
                      <router-view/>
                    </keep-alive>
                  </div>
                </el-tabs>
              </div>
              <i v-if="options.length > 1" @click="closeAll" class="close-content el-icon-circle-close"></i>
            </div>
          </el-main>
          <el-footer style="margin: 0 0 0 12%;">
            <div style="background-color: #F5F7F9">
<!--              <el-row  type="flex" justify="space-between" style="margin-left: 10%;">-->
<!--                <el-col :span="6">-->
<!--                  <div>-->
<!--                    <h3 class="iafuXR">链接</h3>-->
<!--                    <div class="dVkqyQ">-->
<!--                      <a  class="icdoav" href='https://www.seniverse.com' title='天气数据'>心知天气</a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </el-col>-->
<!--                <el-col :span="6">-->

<!--                </el-col>-->
<!--                <el-col :span="6">-->

<!--                </el-col>-->
<!--              </el-row>-->
              <p class="footer">Copyright <a href="https://www.hohofast.com/#/">上海全服通信有限公司</a> © 2016-{{resolvingDate(new Date())}} 版权所有 。</p>
            </div>
          </el-footer>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>
<script>
  //AppNav
  import store from '../store/store'
  import AppNav from '../components/common/AppNav'
  import {checkStrong} from '../components/checkpassStrong.js'
  import {logout, resPwd} from '../api/api'
  import {selectAutomaticorder, updateAutomaticOrder} from '../api/order'
  //import {getWeather} from "../api/system";

  export default {
    name: 'home',
    inject: ['reload'],
    components: {
      AppNav
    },
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'))
        } else {
          if (this.form.new_password2 !== '') {
            this.$refs.form.validateField('new_password2')
          }
          if (!(/^(?=.*[a-z])(?=.*\d)[^]{8,30}$/.test(value))) {
            callback(new Error('最少8个字符，需包含字母及数字'))
          }
          if (value === this.form.old_password) {
            callback(new Error('原密码与新密码不能相同'))
          }
          callback()
        }
      }
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.form.new_password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        isOnline: 1,
        isChangeonline: false,
        menus: [],
        form: {
          loginName: '',
          old_password: '',
          new_password: '',
          new_password2: '',
          checkstrong: '弱',

        },
        rules: {
          user_name: [
            {required: true, message: '请输入用户名', trigger: 'blur'}
          ],
          old_password: [
            {required: true, message: '请输入原密码', trigger: 'blur'}
          ],
          new_password: [
            {validator: validatePass, required: true, trigger: 'blur'}
          ],
          new_password2: [
            {validator: validatePass2, required: true, trigger: 'blur'}
          ]
        },
        billdialog: false,
        labelPosition: 'left',
        hoursTip: '',
        openNames: [this.$route.matched[0].name],
        isShowSetting: false,
        // mobile: '',
        userName: 'admin',
        roleName: '',
        // levelOneName: [],
        // isShowRoutePath: false,
        userInfoForm: {},
        home: {
          changePsw: false,
        },
        weatherInfo: '',
      }
    },
    created() {
      this.getMycount();
      this.deleteRepeatTabs();
    },
    mounted() {
      //获取用户上下线状态
      this.selectAutomaticorderOpe();
      this.getNewStatus();
      this.getMenueData(); //渲染Tab数据
      //this.getWeatherInfo();
      //获取userId
      // 取值时：把获取到的Json字符串转换回对象

    },
    methods: {
      deleteRepeatTabs() {
        let obj = {};
        let options = this.$store.state.options.reduce((cur, next) => {
          obj[next.name] ? "" : obj[next.name] = true && cur.push(next);
          return cur;
        }, []);
        options.forEach((item, index) => {
          this.$store.commit('delete_tabs', item.route);
        })
      },
      selectAutomaticorderOpe() {
        selectAutomaticorder().then(res => {
          if (res.data.status == '100') {
            this.isOnline = res.data.results
          }
        })
      },
      updateAutomaticOrderOpe(tag) {
        this.isChangeonline = true
        let query = {
          customerServicesId: this.userInfoForm.userId,
          automaticOrder: tag
        }
        updateAutomaticOrder(query).then(res => {
          this.isChangeonline = false
          if (res.data.status == '100') {
            this.isOnline = tag
            this.$message({
              message: res.data.message,
              type: 'success'
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        })

      },
      getNewStatus() {
        let userInfoStr = localStorage.getItem('userInfo');
        this.userInfoForm = JSON.parse(userInfoStr);
        // console.log(this.userInfoForm); // => tom
        this.roleName = this.userInfoForm.staffName
        //获取权限列表 Authority
        let AuthListDate = [];
        AuthListDate = JSON.parse(localStorage.getItem('authList'));
        // console.log(AuthListDate)
        // this.home.changePsw= getPermission('/system/dept/userResPwd');
        // console.log(this.authA)
        //获取线上、线下状态
        // this.selectAutomaticorderOpe();
      },
      getMenueData() {
        let menuListDate = [];
        menuListDate = JSON.parse(localStorage.getItem('menuList'));
        let map = {};
        menuListDate.forEach(function (item) {
          map[item.menuId] = item;
        });
        let newData = [];
        //console.log(menuListDate)
        menuListDate.forEach(function (item) {
          var parent = map[item.preId]; // 根据当前遍历对象的pid,去map对象中找到对应索引的id
          if (parent) {
            // 如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
            (parent.children || (parent.children = [])).push(item);
          } else {
            //如果没有在map中找到对应的索引ID,那么直接把当前的item添加到newData结果集中作为顶级
            newData.push(item);
          }
        });
        //console.log(newData)
        this.menus = newData
      },
      //筛选
      getPermission(url) {
        let b = false;
        let GET_PERMISSION_LIST = JSON.parse(window.localStorage.getItem("authList"));
        if (GET_PERMISSION_LIST != null) {
          for (let c of GET_PERMISSION_LIST) {
            if (url == c.autUrlMethod) {
              return true;
            } else {
              b = false;
            }
          }
          return b;
        } else {
          return false;
        }
      },
      //帮助中心
      toHelp: function () {
        this.$router.replace('/HelpPage')
      },
      //判断时间函数；
      getMycount: function () {
        let self = this
        let date = new Date()
        if (date.getHours() >= 0 && date.getHours() < 12) {
          self.hoursTip = "上午好"
        } else if (date.getHours() >= 12 && date.getHours() < 18) {
          self.hoursTip = "下午好"
        } else {
          self.hoursTip = "晚上好"
        }
      },
      // tab切换时，动态的切换路由
      tabClick(tab) {
        let path = this.activeIndex;
        // 用户详情页的时候，对应了二级路由，需要拼接添加第二级路由
        if (this.activeIndex === '/userInfo') {
          path = this.activeIndex + '/' + this.$store.state.userInfo.name;
        }
        this.$router.push({path: path});//路由跳转
      },
      tabRemove(targetName) {
        // 首页不可删除
        if (targetName == '/welcome') {
          return;
        }
        //将该tab从options里移除
        this.$store.commit('delete_tabs', targetName);
        ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
        if (this.activeIndex === targetName) {
          // 设置当前激活的路由
          if (this.options && this.options.length >= 1) {
            this.$store.commit('set_active_index', this.options[this.options.length - 1].route);
            this.$router.push({path: this.activeIndex});
          } else {
            this.$router.push({path: '/welcome'});
          }
        }
      },
      closeAll() {
        this.$store.state.options.forEach((item, index) => {
          this.$store.commit('delete_tabs', item.route);
        })
        this.$router.replace({path: '/welcome'});
        this.reload();
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      toggleSetting() {
        this.isShowSetting = !this.isShowSetting
      },
      //修改密码
      changePsw() {
        this.billdialog = true;
        this.form.loginName = this.userInfoForm.loginName
      },
      //确认修改
      submitFormPsw(formName) {
        this.$confirm("确认修改密码?", "提示", {
          type: "warning"
        }).then(() => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              let para = {
                userId: this.userInfoForm.userId,
                password: this.form.old_password,
                memo: this.form.new_password2
              };
              // console.log(para)
              resPwd(para).then(res => {
                // console.log(res)
                if (res.data.status == 100) {
                  this.billdialog = false;
                  this.$message({
                    message: res.data.message,
                    type: 'success'
                  })
                  localStorage.removeItem("userInfo");
                  this.$router.push('/')
                } else {
                  this.$message({
                    message: res.data.message,
                    type: 'error'
                  })
                }
              });
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //退出
      logout() {
        // this.$store.commit('del_token')
        // this.cookie.delCookie('session')
        // window.localStorage.removeItem("token");
        logout().then((res) => {
          if (res.data.status == 100) {
            window.localStorage.removeItem("token")
            store.commit('del_token')
            this.$router.replace('/loginOut');
          }
        }).catch((error) => {
          this.$Message.error(error.message)
        })
      },
      goBaseMessage() {
        this.$router.push({
          path: '/baseMessage'
        })
        this.isShowSetting = false
      },
      goHome() {
        this.isShowLevel = false
        this.$router.push({
          path: '/welcome'
        })
      },
      //获取天气
      // getWeatherInfo() {
      //   let _self = this;
      //   let params = {};
      //   getWeather(params).then(response => {
      //     if (response.data.status == 100) {
      //       _self.weatherInfo = response.data.results;
      //     }
      //   }).catch((error) => {
      //     this.$Message.error(error.message)
      //   })
      // },
      /*时间格式化*/
      resolvingDate: function (date) {
        if (!date) {
          return "";
        }
        let d = new Date(date);
        return  d.getFullYear();
      }
    },
    computed: {
      options() {
        return this.$store.state.options;
      },
      activeIndex: {
        get() {
          return this.$store.state.activeIndex;
        },
        set(val) {
          this.$store.commit('set_active_index', val);
        }
      },
      userInfo: function () {
        let obj = new Object();
        let menulist = [];
        let j = JSON.parse(window.localStorage.getItem("userInfo"));
        if (j == null) {
          obj.nickName = '';
          return obj;
        } else {
          return j;
        }
      }
    },
    watch: {
      '$route'(to) {
        if (to.name != 'Login') {
          console.log(this.$store.state.options)
          let flag = false;//判断是否页面中是否已经存在该路由下的tab页
          //options记录当前页面中已存在的tab页
          this.getMenueData()  //
          //this.getNewStatus();
          for (let option of this.options) {
            //用名称匹配，如果存在即将对应的tab页设置为active显示桌面前端
            if (option.name === to.name) {
              flag = true;
              this.$store.commit('set_active_index', '/' + to.path.split('/')[1]);
              break;
            }
          }
          //如果不存在，则新增tab页，再将新增的tab页设置为active显示在桌面前端
          if (!flag) {
            this.$store.commit('add_tabs', {route: '/' + to.path.split('/')[1], name: to.name});
            this.$store.commit('set_active_index', '/' + to.path.split('/')[1]);
          }
        }

      },
      'form.new_password'(newValue, oldValue) {
        this.form.checkstrong = checkStrong(newValue);
      },
      'roleName'(newValue, oldValue) {
        //this.selectAutomaticorderOpe();
      }
    }
  }
</script>
<style lang="scss">
  @import '../assets/css/home.css';

  #home {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    display: flex;
    flex-flow: column;
    min-height: 800px;

    .online-status {
      color: #00CD00;
      padding: 5px 10px 5px 10px;
      border: 1px solid #00CD00;
      border-radius: 25px;
      -moz-border-radius: 25px; /* Old Firefox */
      cursor: pointer;
    }

    .offline-status {
      color: #EE3B3B;
      padding: 5px 10px 5px 10px;
      border: 1px solid #EE3B3B;
      border-radius: 25px;
      -moz-border-radius: 25px; /* Old Firefox */
      cursor: pointer;
    }

    .app-content {
      flex: 1;
      display: flex;
      flex-flow: row;
      min-height: 800px;
      /*margin: 60px 0 0 200px;*/
      margin: 3% 0 0 12%;

      .app-wrap {
        flex: 1;
        min-height: 800px;
        position: relative;

        .close-content {
          position: absolute;
          right: 10px;
          font-size: 20px;
          top: 1px;
          cursor: pointer;
          height: 38px;
          line-height: 40px;
          width: 30px;
          background: #F2F6FC;
          z-index: 9;
          text-align: center;
          font-weight: lighter;
          color: #F56C6C
        }

        .content-wrap {
          height: 90%;
          min-height: 800px;
          border-top: none;
          padding: 0 20px;
        }
      }
    }
  }

  header.el-header {
    padding: 0;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 99;
  }

  .layout-hide-text .layout-text {
    display: block;
  }

  .el-tabs .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav .el-tabs__item {
    border-right: 1px solid #dcdfe6;
  }

  .layout-menu-left {
    position: fixed;
    top: 6%;
    bottom: 6%;
    left: 0;
    width: 12% !important;
    height: 100%;
    overflow-y: auto;
    transition: width 0.28s ease-in-out;

    &::-webkit-scrollbar {
      display: none;
    }

    ::-webkit-scrollbar {
      width: 5px;
      height: 10px;
    }

    ::-webkit-scrollbar-track-piece {
      background-color: rgba(0, 0, 0, 0.2);
      -webkit-border-radius: 6px;
    }

    ::-webkit-scrollbar-thumb:vertical {
      height: 5px;
      background-color: rgba(125, 125, 125, 0.7);
      -webkit-border-radius: 6px;
    }

    ::-webkit-scrollbar-thumb:horizontal {
      width: 5px;
      background-color: rgba(125, 125, 125, 0.7);
      -webkit-border-radius: 6px;
    }
  }

  .jhh-layou .layout-menu-left {
    background: #3b3b3b;
    overflow-y: scroll;
    z-index: 12;

  }

  .user-welcome, .user-center {
    color: #fff;
    font-size: 14px;
    font-weight: 600;
  }

  .isActive {
    width: 50px;
    height: 26px;
    background-color: #c41335;
    border-radius: 3px;
    line-height: 26px;
    text-align: center;
    color: #fff;
    margin-top: 6px;
    float: left;
  }

  @keyframes goWidth {
    from {
      width: 50px;
    }
    to {
      width: 100px;
    }
  }

  @-moz-keyframes goWidth /* Firefox */
  {
    from {
      width: 50px;
    }
    to {
      width: 100px;
    }
  }

  @-webkit-keyframes goWidth /* Safari 和 Chrome */
  {
    from {
      width: 50px;
    }
    to {
      width: 100px;
    }
  }

  @-o-keyframes goWidth /* Opera */
  {
    from {
      width: 50px;
    }
    to {
      width: 100px;
    }
  }

  .isActive1 {
    background-color: #fb9b03;
    animation: goWidth 1s;
    -moz-animation: goWidth 1s; /* Firefox */
    -webkit-animation: goWidth 1s; /* Safari 和 Chrome */
    -o-animation: goWidth 1s; /* Opera */
    width: 100px;
  }

  @keyframes goWidth2 {
    from {
      width: 100px;
    }
    to {
      width: 150px;
    }
  }

  @-moz-keyframes goWidth2 /* Firefox */
  {
    from {
      width: 100px;
    }
    to {
      width: 150px;
    }
  }

  @-webkit-keyframes goWidth2 /* Safari 和 Chrome */
  {
    from {
      width: 100px;
    }
    to {
      width: 150px;
    }
  }

  @-o-keyframes goWidth2 /* Opera */
  {
    from {
      width: 100px;
    }
    to {
      width: 150px;
    }
  }

  .isActive2 {
    background-color: #1a9203;
    animation: goWidth2 1s;
    -moz-animation: goWidth2 1s; /* Firefox */
    -webkit-animation: goWidth2 1s; /* Safari 和 Chrome */
    -o-animation: goWidth2 1s; /* Opera */
    width: 150px;
  }

  .default-scrollbar {
    width: 100%;
    height: 100%;
  }

  .flex-scrollbar {
    width: auto;
    height: auto;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }

  .footer {
    text-align: center;
    /*line-height:60px;*/
    /*font-size:12px;*/
  }
  .iafuXR {
    font-size: 16px;
  }
  .dVkqyQ {
    text-overflow: ellipsis;
    white-space: nowrap;
    color: rgba(255, 255, 255, 0.5);
    overflow: hidden;
  }
  .icdoav {
    font-size: 14px;
    cursor: pointer;
    position: relative;
    color: rgba(93, 95, 112, 0.5);
    white-space: nowrap;
    line-height: 28px;
    text-decoration: none;
    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
</style>




// WEBPACK FOOTER //
// Home.vue?33be836e